var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17079",
    "data-name": "Group 17079",
    transform: "translate(-18 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat",
    d: "M14.708,0h-8.4a6.306,6.306,0,0,0-6.3,6.3v4.9a6.307,6.307,0,0,0,5.95,6.289v2.92a.6.6,0,0,0,.6.594.589.589,0,0,0,.418-.175l.657-.656A9.071,9.071,0,0,1,14.085,17.5h.623a6.306,6.306,0,0,0,6.3-6.3V6.3A6.306,6.306,0,0,0,14.708,0ZM5.958,10.147a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,5.958,10.147Zm4.55,0a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,10.508,10.147Zm4.55,0a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,15.058,10.147Z",
    transform: "translate(17.992 18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_372",
    "data-name": "Ellipse 372",
    transform: "translate(34 13)",
    fill: "#fff",
    stroke: "#ec6321",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage01);
export default __webpack_public_path__ + "static/media/message 01.c064f9ae1c4ecc37060e6e27407bda9d.svg";
export { ForwardRef as ReactComponent };